import {
  CommonModule,
  isPlatformBrowser,
  ViewportScroller,
} from "@angular/common";
import { Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterModule,
  Scroll,
} from "@angular/router";

// import { GoogleTagManagerService } from "angular-google-tag-manager";
// import { ConsoleLoggerService } from "logging";
import { BnNgIdleService } from "bn-ng-idle";
import { componentDestroyed } from "ng2-rx-componentdestroyed";
import { filter, share, takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";

// import ua from 'universal-analytics';
import { JwtHelperService } from "@auth0/angular-jwt";
// import { MetaService } from "@ngx-meta/core";
import { CommonService } from "@services/common.service";
import { SharedService } from "@services/shared.service";
import { YTBSEOService } from "@services/ytb-seo.service";

import * as metacontent from "./metacontent";
import { HeaderModule } from "@layout/header/header.module";
import { NewsletterModule } from "./newsletter/newsletter.module";
import { FooterModule } from "@layout/footer/footer.module";
import { HeaderPageComponent } from "@layout/header/header-page/header-page.component";
import { IdleService } from "./core/utils/idle.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

declare var gtag;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderPageComponent,
    NewsletterModule,
    FooterModule,
  ],
})
export class AppComponent implements OnInit {
  title = "Your Travel Booking - Hotels, Flights, Cars & Activities";
  metacontent = metacontent.Homepage;
  appLoadEnd: boolean = false;
  token: string;
  private idleStarted = false;
  // visitor = ua('UA-153681575-1');
  private destroyRef = inject(DestroyRef);

  constructor(
    // logserv: ConsoleLoggerService,
    private router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private bnIdle: BnNgIdleService,
    private viewPortScroller: ViewportScroller,
    private meta: Meta,
    private ytbSeoService: YTBSEOService,
    private commonservice: CommonService,
    private sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId,
    private readonly metaService: Meta,
    private idleService: IdleService,
    // private gtmService: GoogleTagManagerService
  ) {
    let defaObj = { ecommerce: null };
    // this.gtmService.pushTag(defaObj);
  }
  
  ngOnInit() {
    const helper = new JwtHelperService();
    this.commonservice.SITEMAINTAINANCEEXCEPTIONSUCCESS$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((res) => {
      if (res) {
        this.router.navigate(["sitemaintainance"]);
      }
    });
    this.commonservice.EXCEPTIONSUCCESS$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((res) => {
      if (res) {
        this.commonservice.logError({
          logLevel: "Error page Navigation Before",
          message: "App Component EXCEPTIONSUCCESS From App Component ",
        });
        this.router.navigate(["error"]);
      }
    });

    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (
          isPlatformBrowser(this.platformId) &&
          typeof window !== "undefined"
        ) {
          window.scrollTo(0, 0);
        }
        // Here we are integrating with Google Analytics

        // gtag('config', 'UA-153681575-1',{
        //   'page_path' : e.urlAfterRedirects
        // });
        const gtmTag = {
          event: "page",
          pageName: e.urlAfterRedirects,
        };

        // this.gtmService.pushTag(gtmTag);
        if (
          isPlatformBrowser(this.platformId) &&
          typeof window !== "undefined"
        ) {
          setTimeout(() => {
            if (e.url != "/") {
              this.metaService.addTag({
                name: "og:url",
                content: "https://www.yourtravelbooking.com" + e.url,
              });
              if (
                isPlatformBrowser(this.platformId) &&
                typeof window !== "undefined"
              ) {
                window.scroll(0, 0);
              }
              const child = this.activatedRoute.firstChild;

              //   if (child.snapshot.data["title"] != undefined) {
              //     if (!child.snapshot.data["title"].includes("$")) {
              //       console.log(
              //         e.url.indexOf("?"),
              //         "  Insid eof seet title   ",
              //         e.url
              //       );

              //       if (e.url.indexOf("?") > -1) {
              //         let urlString = e.url.split("?");
              //         this.ytbSeoService.addMetaTags(urlString[0]);
              //       } else {
              //         this.ytbSeoService.addMetaTags(e.url);
              //       }

              //       this.titleService.setTitle(child.snapshot.data["title"]);
              //       this.metaService.setTitle(child.snapshot.data["title"], true);
              //       this.metaService.setTag(
              //         "twitter:title",
              //         child.snapshot.data["title"]
              //       );
              //       this.metaService.setTag(
              //         "og:title",
              //         child.snapshot.data["title"]
              //       );
              //       this.ytbSeoService.setDynamicTitle(
              //         child.snapshot.url[0].path,
              //         child.snapshot.data["title"]
              //       );
              //       this.ytbSeoService.setMetaImageDesc(
              //         "https://yourtravelbooking.com" +
              //           child.snapshot.data["image"]
              //       );
              //     } else {
              //       this.activatedRoute.queryParams.subscribe((res) => {
              //         console.log("Inside of if query params ", res);
              //       });
              //     }
              //   }
              // } else {

              //   this.ytbSeoService.setDynamicTitle(
              //     'child.snapshot.url[0].path',
              //     "Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking"
              //   );

              //   this.ytbSeoService.setMetaImageDesc(
              //     "https://yourtravelbooking.com/assets/ytb-images/ytb_logo.png"
              //   );
              //   this.ytbSeoService.addMetaTags('/flight');

              // Start idle watcher only if not already started. Prevent multiple
              // overlapping watchers/modal instances by tracking `idleStarted`
              // and checking `Swal.isVisible()` before showing a new alert.
              if (!this.idleStarted) {
                this.idleStarted = true;
                this.idleService.startWatching(() => {
                  // stop watching immediately to avoid repeated triggers
                  try {
                    this.idleService.stopWatching();
                  } catch (e) {
                    // ignore stop errors
                  }
                  this.idleStarted = false;

                  // If a modal is already visible, don't open another one
                  if (Swal && (Swal as any).isVisible && (Swal as any).isVisible()) {
                    return;
                  }

                  const currentUrl = this.router.url;
                  if (
                    currentUrl.includes("search/flights") ||
                    currentUrl.includes("lp/flights") ||
                    currentUrl.includes("flight-details") ||
                    currentUrl.includes("book/flight")
                  ) {
                    Swal.fire({
                      title: "Your Session Expired",
                      text: "Your booking session has timed out for security reasons. Please refresh or log in again to continue planning your travel plans",
                      allowOutsideClick: false,
                    }).then(() => {
                      this.idleStarted = false;
                      try {
                        Swal.close();
                      } catch (e) {}
                      this.router.navigate(["/"]);
                      this.reloadCurrentPage();
                    });
                  }
                });
              }
            } else {
              if (e.url === "/" || e.url === "/home/flight") {
                this.idleService.stopWatching();
                this.idleStarted = false;
                Swal.close();
                this.router.navigate(["/"]);
                // this.reloadCurrentPage();
                setTimeout(() => {
                  this.ytbSeoService.createCanonicalURL("/search/flightstest");
                  this.ytbSeoService.setDynamicTitle("/search/flightstest");
                }, 2000);
              }
            }
          });

          this.appLoadEnd = true;
        }

        if (
          e.url != "/flight" &&
          e.url != "/hotel" &&
          e.url != "/car" &&
          e.url != "/activities"
        ) {
          // if (e instanceof Scroll) {
          //   if (e.position) {
          //     this.viewPortScroller.scrollToPosition(e.position);
          //   } else if (e.anchor) {
          //     this.viewPortScroller.scrollToAnchor(e.anchor);
          //   } else {
          //     this.viewPortScroller.scrollToPosition([0, 0]);
          //   }
          // }
        }
      }

      if (e instanceof NavigationStart) {
        this.appLoadEnd = false;
      }
    });

    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      // this.bnIdle.startWatching(2700).subscribe((isTimedOut: boolean) => {
      //   if (this.router.url != "/") {
      //     // this.metaService.setTag(
      //     //   "og:url",
      //     //   "https://www.yourtravelbooking.com" + url
      //     // );
      //     const child = this.activatedRoute.firstChild;
      //     // if (
      //     //   child.snapshot.data["navigateurl"] != undefined &&
      //     //   child.snapshot.data["navigateurl"] != null
      //     // ) {

      //     Swal.fire({
      //       title: "Your Session Expired",
      //       allowOutsideClick: false,
      //     }).then((ok) => {
      //       this.sharedService.clearSelectedFlightAfterTimeout.emit(true);

      //       this.bnIdle.stopTimer();
      //       this.router.navigate(["/"]);
      //       setTimeout(() => {
      //         if (
      //           isPlatformBrowser(this.platformId) &&
      //           typeof window !== "undefined"
      //         ) {
      //           window.location.reload();
      //         }
      //       }, 1000);
      //     });
      //     // }
      //   }
      // });

      // this.bnIdle.startWatching(720).subscribe((isTimedOut: boolean) => {
      //   if (isTimedOut && this.router.url !== "/") {
      //     Swal.fire({
      //       title: "Your Session Expired",
      //       allowOutsideClick: false,
      //     }).then(() => {
      //       this.sharedService.clearSelectedFlightAfterTimeout.emit(true);
      //       this.bnIdle.stopTimer();
      //       this.router.navigate(["/"]);
      //     });
      //   }
      // });
      // this.router.events
      //   .pipe(filter((event) => event instanceof NavigationEnd))
      //   .subscribe((event: any) => {
      //     const url = event.urlAfterRedirects;
      //     if (
      //       !this.idleStarted &&
      //       (url.includes("search/flights") ||
      //         url.includes("lp/flights") ||
      //         url.includes("flight-details") ||
      //         url.includes("book/flight"))
      //     ) {
      //       this.idleService.startWatching(() => {
      //         this.idleStarted = true;
      //         this.idleService.stopWatching();
      //         Swal.fire({
      //           title: "Your Session Expired",
      //           text: "Your booking session has timed out for security reasons. Please refresh or log in again to continue planning your travel plans",
      //           allowOutsideClick: false,
      //         }).then(() => {
      //           this.router.navigate(["/"]);
      //           this.idleService.stopWatching(); // important
      //           this.idleStarted = false;
      //           this.router.navigate(["/"]);
      //           setTimeout(() => {
      //             if (isPlatformBrowser(this.platformId)) {
      //               window.location.reload(); // reload SSR page
      //             }
      //           });
      //         });
      //       });
      //     } else {
      //       this.idleService.stopWatching();
      //       console.log(
      //         "Idle timer not started for url: ############",
      //         url,
      //         url.includes("search/flights") ||
      //           url.includes("lp/flights") ||
      //           url.includes("flight-details") ||
      //           url.includes("book/flight"),
      //       );
      //     }
      //   });

      // if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      //   // Listen for offline event
      //   window.addEventListener("offline", () => {
      //     this.idleService.stopWatching();
      //     this.idleStarted = false;
      //     this.router.navigate(["/"]);
      //   });
      // }
      if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
        window.addEventListener("offline", this.handleOffline);
      }

      if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
        if (navigator.onLine) {
          // this.router.events
          //   .pipe(filter((event) => event instanceof NavigationEnd))
          //   .subscribe((event: any) => {
          //     const url = event.urlAfterRedirects;
          //     if (
          //       url.includes("search/flights") ||
          //       url.includes("lp/flights") ||
          //       url.includes("flight-details") ||
          //       url.includes("book/flight")
          //     ) {
          //       if (!this.idleStarted) {
          //         this.idleStarted = true;
          //         this.idleService.startWatching(() => {
          //           this.idleService.stopWatching();
          //           this.idleStarted = false;
          //           if (this.router.url !== "/") {
          //             Swal.fire({
          //               title: "Your Session Expired",
          //               text: "Your booking session has timed out for security reasons. Please refresh or log in again to continue planning your travel plans",
          //               allowOutsideClick: false,
          //             }).then(() => {
          //               this.idleStarted = false;
          //               this.router.navigate(["/"]);
          //               if (isPlatformBrowser(this.platformId)) {
          //                 window.location.reload();
          //               }
          //             });
          //           }
          //         });
          //       }
          //     } else {
          //       this.idleService.stopWatching();
          //       this.idleStarted = false;
          //     }
          //   });
        } else {
          Swal.close();
          this.router.navigate(["/"]);
          this.idleService.stopWatching();
          this.idleStarted = false;
          this.reloadCurrentPage();
        }
      }

      if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
        window.removeEventListener("load", () => {
          window.removeEventListener("online", () => {});

          window.removeEventListener("offline", () => {});
        });
      }
      if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
        // window.addEventListener("load", () => {
        //   window.addEventListener("online", () => {
        //     if (this.router.url == '/') { //if user sits in home page
        //       setTimeout(() => {
        //         window.location.reload();
        //       }, 1000);
        //     } else { //if in other page
        //       this.router.navigate(['/']);
        //       setTimeout(() => {
        //         window.location.reload();
        //       }, 1000);
        //     }
        //   });
        // window.addEventListener("offline", () => {
        //   if (localStorage.getItem('clientip') != null && localStorage.getItem('clientip') != undefined) {
        //   }
        // });
        // });
      }
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      document.body.className = "bodytag";
    }

    this.sharedService.rememberMeUserDetails$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        if (res) {
          this.sharedService.loginDataAlreadyAvailable$.next(res);
        }
      });
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      window.removeEventListener("offline", this.handleOffline);
    }
    this.commonservice.dispose();
  }

  private handleOffline = () => {
    // Swal.close();
    // this.idleService.stopWatching();
    // this.idleStarted = false;
    // this.router.navigate(["/"]);
    // this.reloadCurrentPage();
  };

  private reloadCurrentPage() {
    Swal.close();
    this.idleService.stopWatching();
    this.idleStarted = false;
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        window.location.reload();
      }
    }, 100);
  }
}
